import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import {
  IFilter,
  IQueryParam,
  IReporteGenerico,
  TipoValoresReporte,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../auxiliares/tabla/filtro/filtro.component';
import { IColumnas } from '../../auxiliares/tabla/tabla.component';
import { AuxiliaresModule } from '../../auxiliares/auxiliares.module';
import { Lista2Service } from '../../auxiliares/servicios/lista2.service';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-listado-reportes-temperatura',
  templateUrl: './listado-reportes-temperatura.component.html',
  styleUrl: './listado-reportes-temperatura.component.scss',
})
export class ListadoReportesTemperaturaComponent
  implements OnInit, OnDestroy, OnChanges
{
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);

  @Input() public idTracker?: string;
  @Input() public idActivo?: string;

  public name = 'ListadoReportesTemperaturaComponent';
  public reportes?: IReporteGenerico[];
  public reportes$?: Subscription;
  public totalCount = 0;
  public columnas: IColumnas<IReporteGenerico>[];

  public search: IRegExpSearch = { fields: [] };

  private fecha: IFiltroTabla = {
    filter: { field: 'fechaCreacion' },
    label: 'Fecha',
    tipo: 'dateRange',
  };

  public cliente: IFiltroTabla = {
    filter: { field: 'idCliente' },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };

  public filtros: IFiltroTabla[] = [this.fecha, this.cliente, this.ancestro];

  public query: IQueryParam = {
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  public async listar(): Promise<void> {
    const filter: IFilter<IReporteGenerico> = JSON.parse(
      this.query.filter || '{}',
    );

    if (this.idTracker) filter.idEntidad = this.idTracker;
    if (this.idActivo) filter.idsAsignados = this.idActivo;

    this.query.filter = JSON.stringify(filter);

    this.reportes$?.unsubscribe();
    this.reportes$ = this.lista2
      .reportesGenericos(
        ['Tracker 4G Temperatura'] as unknown as TipoValoresReporte[],
        this.query,
        30,
      )
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.reportes = data.datos;
      });
  }

  private setColumnas(): void {
    this.columnas = [
      {
        header: { label: 'Fecha', sortable: true, sort: 'fechaCreacion' },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
          noData: 'Sin fecha',
        },
      },
      {
        header: { label: 'Temperatura' },
        row: {
          parse: (dato) => {
            const t = (dato.valores as any)?.temperatura;
            if (t === undefined || t === null) return undefined;
            const valor = (t as number).toLocaleString('es-AR', {
              maximumFractionDigits: 2,
            });
            return `${t > 0 ? '+' : ''}${valor} °C`;
          },
          noData: 'Sin dato',
        },
      },
    ];
  }

  async ngOnInit() {
    this.setColumnas();
    await this.listar();
  }

  async ngOnChanges() {
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.reportes$?.unsubscribe();
  }
}
